<template>
    <div class= "cardComponente d-flex flex-column align-items-center" :class="isErro ? 'card-status-erro' : 'card-status-ok'">
        <div class="cardHeader d-flex flex-column justify-content-center align-items-center">
            <p>{{ textoHeader }}</p>
        </div >
        <div class="cardBody d-flex flex-column justify-content-center align-items-center text-center">
            <WifiIcon :color="isErro ? 'var(--cor-erro)' : 'var(--cor-ok)'" />
            <p :class="textoCardClass" >{{textoCard}}</p>
        </div>
        <p class="footerText">{{textoFooter}}</p>
    </div>
</template>

<script>

	export default {
		name: "CardStatus",
		props: {
			textoCard: { type: String },
			textoHeader: { type: String },
			textoFooter: { type: String },
			textoCardClass: {type: String },
			isErro: {
				type: Boolean,
				default: true
			}
		}
	};
</script>

<style scoped>
    .cardComponente{
        height: 173px;
        width: 260px;
        background-color: var(--bg-primario);
        border-radius: 16px;
        border: 2px solid var(--cor-erro);

    }

    .cardHeader {
        background-color: var(--cor-erro);
        height: 25%;
        width: 100%;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        color: var(--bg-primario);
        padding-top: 15px;
    }


    .cardBody {
        gap: 0.5em;
        padding: 0.7em;
        font-size: 13px;
        margin-top: auto;


    }
    .footerText {
        font-size: 9px;
        align-self: flex-start;
        padding-left: 2em;
        margin-top: auto;
    }

    p{
        font-family: var(--fonte-semi-bold);
        white-space: pre-line;
    }

    .card-status-erro {
        border: 2px solid var(--cor-erro);
    }
    .card-status-erro .cardHeader {
        background-color: var(--cor-erro);
    }

    .card-status-ok {
        border: 2px solid var(--cor-ok);
    }
    .card-status-ok .cardHeader {
        background-color: var(--cor-ok);
    }
    .cardComponente:hover  {
        cursor: pointer;
        opacity: 0.9;
    }
</style>